import "./App.css";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { BrowserRouter, Route, Routes  } from "react-router-dom";
import Home from "./component/Shopkeeper/Home";
import Login from "./Login";
import Verify from "./Verify";
import AddPromo from "./component/Shopkeeper/AddPromo";
import Profile from "./component/Shopkeeper/Profile";
import Pricing from "./component/Shopkeeper/Pricing";
import Price from "./component/Shopkeeper/Price";


function App() {
  return (
    <>
      <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login/>}/>
        <Route path="/verify" element={<Verify/>}/>
        <Route path="/shophome" element={<Home/>}/>
        <Route path="/addpromotions" element={<AddPromo/>}/>
        <Route path="/shopProfile" element={<Profile/>}/>
         <Route path="/shopPricing" element={<Pricing/>}/>
          <Route path="/pricing" element={<Price/>}/>
      </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
